/**
 * PDP Zoom Lightbox — fullscreen image viewer
 * Opens on gallery image click, supports prev/next navigation and keyboard controls.
 */
(function () {
  'use strict';

  function initZoomLightbox() {
    var wrapper = document.querySelector('.main-product-section .main-product-media-wrapper, .featured-product-section .main-product-media-wrapper');
    var lightbox = wrapper ? wrapper.querySelector('[data-zoom-lightbox]') : null;
    if (!lightbox || lightbox.dataset.zoomInit === 'done') return;
    lightbox.dataset.zoomInit = 'done';

    // Move lightbox to body to escape overflow:hidden on parent containers
    document.body.appendChild(lightbox);

    var imgEl = lightbox.querySelector('[data-zoom-image]');
    var counterEl = lightbox.querySelector('[data-zoom-counter]');
    var closeBtn = lightbox.querySelector('[data-zoom-close]');
    var prevBtn = lightbox.querySelector('[data-zoom-prev]');
    var nextBtn = lightbox.querySelector('[data-zoom-next]');

    // Collect all zoomable image URLs from visible slides
    function getImageUrls() {
      var slides = wrapper.querySelectorAll('.featured-product-slider .swiper-slide');
      var urls = [];
      slides.forEach(function (slide) {
        if (slide.offsetWidth === 0) return; // skip hidden
        var img = slide.querySelector('img');
        if (img) {
          // Use the highest resolution available from srcset or src
          var src = img.src || '';
          // Try to get full-res URL by removing width params
          if (src.includes('width=')) {
            src = src.replace(/&?width=\d+/, '').replace(/\?width=\d+&?/, '?').replace(/\?$/, '');
          }
          urls.push(src);
        }
      });
      return urls;
    }

    var currentZoomIndex = 0;
    var zoomImages = [];

    function updateZoom(idx) {
      if (zoomImages.length === 0) return;
      if (idx < 0) idx = zoomImages.length - 1;
      if (idx >= zoomImages.length) idx = 0;
      currentZoomIndex = idx;
      imgEl.src = zoomImages[idx];
      imgEl.alt = 'Product image ' + (idx + 1);
      if (counterEl) {
        var current = String(idx + 1).padStart(2, '0');
        var total = String(zoomImages.length).padStart(2, '0');
        counterEl.textContent = current + '/' + total;
      }
    }

    var lightboxFocusTrap = null;

    function openZoom(startIdx) {
      zoomImages = getImageUrls();
      if (zoomImages.length === 0) return;
      updateZoom(startIdx || 0);
      lightbox.classList.add('is-open');
      lightbox.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      if (typeof window.FocusTrap !== 'undefined') {
        lightboxFocusTrap = window.FocusTrap.activate(lightbox, {
          onEscape: function() { closeZoom(); }
        });
      }
    }

    function closeZoom() {
      lightbox.classList.remove('is-open');
      lightbox.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      if (lightboxFocusTrap) {
        lightboxFocusTrap.deactivate();
        lightboxFocusTrap = null;
      }
      // Reset zoom state
      var container = lightbox.querySelector('[data-zoom-image-container]');
      if (container) {
        container.classList.remove('is-zoomed');
        container.scrollTop = 0;
        container.scrollLeft = 0;
      }
    }

    // Close button
    if (closeBtn) closeBtn.addEventListener('click', closeZoom);

    // Prev/Next
    if (prevBtn) prevBtn.addEventListener('click', function () { updateZoom(currentZoomIndex - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { updateZoom(currentZoomIndex + 1); });

    // Click-to-zoom on lightbox image
    var imageContainer = lightbox.querySelector('[data-zoom-image-container]');

    // Drag-to-pan state (when zoomed) and swipe-to-navigate state (when not zoomed)
    var isDragging = false;
    var dragStartX = 0;
    var dragStartY = 0;
    var scrollStartX = 0;
    var scrollStartY = 0;
    var hasDragged = false;
    var justZoomedOut = false;

    // Swipe-to-navigate state (when not zoomed)
    var isSwiping = false;
    var swipeStartX = 0;
    var swipeStartY = 0;
    var swipeDeltaX = 0;
    var swipeLocked = false; // locked to horizontal once threshold met
    var SWIPE_THRESHOLD = 40;
    var justSwiped = false;

    function onPointerDown(e) {
      if (imageContainer.classList.contains('is-zoomed')) {
        // Drag-to-pan when zoomed
        isDragging = true;
        hasDragged = false;
        dragStartX = e.clientX;
        dragStartY = e.clientY;
        scrollStartX = imageContainer.scrollLeft;
        scrollStartY = imageContainer.scrollTop;
        imageContainer.setPointerCapture(e.pointerId);
        e.preventDefault();
      } else {
        // Swipe-to-navigate when not zoomed
        isSwiping = true;
        swipeLocked = false;
        swipeDeltaX = 0;
        swipeStartX = e.clientX;
        swipeStartY = e.clientY;
        imageContainer.setPointerCapture(e.pointerId);
      }
    }

    function onPointerMove(e) {
      if (isDragging) {
        var dx = e.clientX - dragStartX;
        var dy = e.clientY - dragStartY;
        if (Math.abs(dx) > 3 || Math.abs(dy) > 3) hasDragged = true;
        imageContainer.scrollLeft = scrollStartX - dx;
        imageContainer.scrollTop = scrollStartY - dy;
      } else if (isSwiping) {
        swipeDeltaX = e.clientX - swipeStartX;
        var swipeDeltaY = e.clientY - swipeStartY;
        // Lock to horizontal swipe once threshold met
        if (!swipeLocked && (Math.abs(swipeDeltaX) > 10 || Math.abs(swipeDeltaY) > 10)) {
          if (Math.abs(swipeDeltaX) > Math.abs(swipeDeltaY)) {
            swipeLocked = true;
            e.preventDefault();
          } else {
            // Vertical scroll — cancel swipe
            isSwiping = false;
          }
        }
        if (swipeLocked) {
          e.preventDefault();
          imgEl.style.transform = 'translateX(' + swipeDeltaX + 'px)';
          imgEl.style.transition = 'none';
        }
      }
    }

    function onPointerUp(e) {
      if (isDragging) {
        isDragging = false;
        imageContainer.releasePointerCapture(e.pointerId);
        // If user didn't drag, treat as a click to zoom out
        if (!hasDragged && imageContainer.classList.contains('is-zoomed')) {
          imageContainer.classList.remove('is-zoomed');
          imageContainer.scrollTop = 0;
          imageContainer.scrollLeft = 0;
          justZoomedOut = true;
        }
      } else if (isSwiping) {
        isSwiping = false;
        imageContainer.releasePointerCapture(e.pointerId);
        if (swipeLocked) {
          // Animate back or switch image
          imgEl.style.transition = 'transform 0.2s ease';
          imgEl.style.transform = '';
          if (Math.abs(swipeDeltaX) > SWIPE_THRESHOLD) {
            if (swipeDeltaX < 0) {
              updateZoom(currentZoomIndex + 1);
            } else {
              updateZoom(currentZoomIndex - 1);
            }
          }
          swipeDeltaX = 0;
          justSwiped = true;
        }
      }
    }

    imageContainer.addEventListener('pointerdown', onPointerDown);
    imageContainer.addEventListener('pointermove', onPointerMove);
    imageContainer.addEventListener('pointerup', onPointerUp);
    imageContainer.addEventListener('pointercancel', onPointerUp);
    // Prevent default touch scrolling on the image container when lightbox is open
    imageContainer.style.touchAction = 'none';

    // Prevent native drag on the image
    imgEl.addEventListener('dragstart', function (e) { e.preventDefault(); });

    function toggleImageZoom(e) {
      if (!imageContainer) return;
      var isZoomed = imageContainer.classList.contains('is-zoomed');
      if (isZoomed) {
        // Zoom-out is handled in onPointerUp when zoomed
        return;
      }
      imageContainer.classList.add('is-zoomed');
      // Center the scroll on the clicked point
      requestAnimationFrame(function () {
        var rect = imageContainer.getBoundingClientRect();
        var clickXRatio = (e.clientX - rect.left) / rect.width;
        var clickYRatio = (e.clientY - rect.top) / rect.height;
        var maxScrollX = imageContainer.scrollWidth - imageContainer.clientWidth;
        var maxScrollY = imageContainer.scrollHeight - imageContainer.clientHeight;
        imageContainer.scrollLeft = maxScrollX * clickXRatio;
        imageContainer.scrollTop = maxScrollY * clickYRatio;
      });
    }

    imgEl.addEventListener('click', function (e) {
      e.stopPropagation();
      if (justZoomedOut) {
        justZoomedOut = false;
        return;
      }
      if (justSwiped) {
        justSwiped = false;
        return;
      }
      toggleImageZoom(e);
    });

    // Reset zoom when changing images
    var origUpdateZoom = updateZoom;
    updateZoom = function (idx) {
      if (imageContainer) imageContainer.classList.remove('is-zoomed');
      origUpdateZoom(idx);
    };

    // Click on lightbox background to close (but not on image)
    lightbox.addEventListener('click', function (e) {
      if (e.target === lightbox) {
        closeZoom();
      }
    });

    imageContainer.addEventListener('click', function (e) {
      if (justZoomedOut) {
        justZoomedOut = false;
        return;
      }
      if (justSwiped) {
        justSwiped = false;
        return;
      }
      if (e.target === imageContainer && !imageContainer.classList.contains('is-zoomed')) {
        closeZoom();
      }
    });

    // Keyboard navigation
    document.addEventListener('keydown', function (e) {
      if (!lightbox.classList.contains('is-open')) return;
      if (e.key === 'Escape') closeZoom();
      if (e.key === 'ArrowLeft') updateZoom(currentZoomIndex - 1);
      if (e.key === 'ArrowRight') updateZoom(currentZoomIndex + 1);
    });

    // Click on gallery slides to open zoom
    var slides = wrapper.querySelectorAll('.featured-product-slider .swiper-slide');
    slides.forEach(function (slide) {
      slide.addEventListener('click', function (e) {
        // Don't open zoom if user was dragging
        if (e.defaultPrevented) return;
        var visibleSlides = Array.from(slides).filter(function (s) { return s.offsetWidth > 0; });
        var idx = visibleSlides.indexOf(slide);
        if (idx >= 0) openZoom(idx);
      });
    });

    // Mobile zoom trigger button
    var zoomTrigger = wrapper.querySelector('.zoom-trigger');
    if (zoomTrigger) {
      zoomTrigger.addEventListener('click', function () {
        openZoom(0);
      });
    }

    // Prevent zoom links from opening (the old PhotoSwipe links)
    var zoomLinks = wrapper.querySelectorAll('.product-media-zoom');
    zoomLinks.forEach(function (link) {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setTimeout(initZoomLightbox, 200); });
  } else {
    setTimeout(initZoomLightbox, 200);
  }

  document.addEventListener('shopify:section:load', function () {
    setTimeout(initZoomLightbox, 300);
  });
})();
